import { helpers, required } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";

const { locale } = await useLocale("validation");

export default {
  credit: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    maxValue: helpers.withMessage(
      () => locale?.value?.max_credit ?? validationJson.max_credit,
      (value: any) => value === "custom" || Number(value) <= GENERIC_MAX_CREDIT
    )
  },
};
